import {getTestProps} from '@benchling/js-test-utils';
import {css} from 'aphrodite';
import React from 'react';

import {BLUE_DARKER, BLUE_LIGHTEST} from 'ui-library/Colors';
import BenchlingDuotoneIcon from 'ui-library/icons/BenchlingDuotoneIcon';

import {agentProgressStyles} from './ChatProgress';

export interface ThinkingSpinnerProps {
  text?: string;
  testComponent?: string;
}

/**
 * Shared "Thinking" spinner header used by both deep research and data capture progress.
 * Shows a spinning icon with customizable text.
 */
export function ThinkingSpinner({text = 'Thinking', testComponent}: ThinkingSpinnerProps): JSX.Element {
  return (
    <div
      className={css(agentProgressStyles.thinkingSection)}
      {...(testComponent
        ? getTestProps({
            component: testComponent,
            element: 'thinkingSection',
          })
        : {})}
    >
      <BenchlingDuotoneIcon
        icon="spinner-third"
        primaryColor={BLUE_DARKER}
        secondaryColor={BLUE_LIGHTEST}
        spin={true}
      />
      <span className={css(agentProgressStyles.thinkingText)}>{text}</span>
    </div>
  );
}
